import { FormProvider } from 'react-hook-form';

import { DataTable } from '@/components/ui/data.table/data-table';
import HeadingWrapper from '@/components/ui/heading/heading-wrapper';
import PageHeading from '@/components/ui/heading/page-headeing';
import PaginationComponent from '@/components/ui/pagination';
import { DEFAULT_PAGE_LIMIT, DEFAULT_PAGE_NUMBER } from '@/constants';

import { transactionsColumns } from './transactions.column';
import { TransactionFilters } from './transactions.filter';
import { useTransactions } from './transactions.hook';

export const Transactions = () => {
    const { data, isError, isLoading, form } = useTransactions();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isError) {
        return <div>Error loading transactions</div>;
    }

    return (
        <>
            <HeadingWrapper>
                <div className="flex items-center justify-between py-4">
                    <PageHeading
                        title="All Transactions"
                        subTitle="Manage Your Transactions"
                    />

                    <div className="flex gap-4">
                        <FormProvider {...form}>
                            <TransactionFilters />
                        </FormProvider>
                    </div>
                </div>
            </HeadingWrapper>

            <DataTable columns={transactionsColumns} data={data?.data || []} />

            <p className=" mt-3 flex w-full items-center px-4 text-right text-[20px] font-semibold">
                Total Found : {data?.pagination?.total_items}
            </p>
            <PaginationComponent
                totalItems={data?.pagination?.total_items || 0}
                itemsPerPage={data?.pagination?.limit || DEFAULT_PAGE_LIMIT}
                initialPage={DEFAULT_PAGE_NUMBER}
                onPageChange={(_p) => {
                    // setCurrentPage(p);
                }}
            />
        </>
    );
};
